"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DrawerHeaderTitle", {
    enumerable: true,
    get: function() {
        return DrawerHeaderTitle;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useDrawerHeaderTitle = require("./useDrawerHeaderTitle");
const _renderDrawerHeaderTitle = require("./renderDrawerHeaderTitle");
const _useDrawerHeaderTitleStylesstyles = require("./useDrawerHeaderTitleStyles.styles");
const DrawerHeaderTitle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useDrawerHeaderTitle.useDrawerHeaderTitle_unstable)(props, ref);
    (0, _useDrawerHeaderTitleStylesstyles.useDrawerHeaderTitleStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useDrawerHeaderTitleStyles_unstable')(state);
    return (0, _renderDrawerHeaderTitle.renderDrawerHeaderTitle_unstable)(state);
});
DrawerHeaderTitle.displayName = 'DrawerHeaderTitle';
